import { APIClient } from "api/api_helper";
import { Study_API, SUBJECT_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// Study API
// ------------------------------------------------------------------

export const masterStudyApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
    studyid?: number | null
  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
      studyid:studyid
    };

    return api.create(Study_API.Study_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (id: number) => {
    const payload = {
      studyid: id,
    };
    return api.create(
      Study_API.Study_API + "Select", payload
    );
  },

  insertData: (payload: any) => {
    return api.create(SUBJECT_API.ADD_SUBJECT + "Upsert", payload);
  },

  getDropDownData: (id: number,includedraft:boolean) => {
    const payload = {
      volunteerid: id,
      status: "A",
      includedraft:includedraft
    };
    return api.create(Study_API.Study_API + "Dropdown", payload);
  },

  getChecklistSelectAllData: (
    studyid?: number | null,
    checklisttype?: string,
    periodnumber?: string,
    searchtext?: string | null,
  ) => {
    const payload = {
      studyid: studyid,
      checklisttype: checklisttype,
      periodnumber: periodnumber,
      searchtext: searchtext ? searchtext.trim() : null,
    };
    return api.create(Study_API.CHECKLIST_SELECTALL + "SelectAll", payload);
  },

  insertChecklistData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const fullPayload = {
      updatedby:user?.userid,
      ...payload,
    };
    return api.create(Study_API.CHECKLIST_SELECTALL + "Insert", fullPayload);
  },

  updateChecklistData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const fullPayload = {
      updatedby: user?.userid,
      ...payload,
    };
    return api.create(Study_API.CHECKLIST_SELECTALL + "Update", fullPayload);
  },

  getPeriodVisibilityData: (
    studyid?: number | null,
    tabname?: string
  ) => {
    const payload = {
      studyid: studyid,
      tabname: tabname,
    };
    return api.create(Study_API.CHECKLIST_SELECTALL + "PeriodVisibility", payload);
  },

  getSubjectCRFSelectAllData: (
    studyid?: number | null,
    periodnumber?: string,
    searchtext?: string | null,
    crfmodule?: string | null,
    pageNumber?: number | null,
    pageSize?: number | null,
  ) => {
    const payload = {
      studyid: studyid,
      periodnumber: periodnumber,
      searchtext: searchtext ? searchtext.trim() : "",
      crfmodule: crfmodule || null,
      currentpage: pageNumber || null,
      pagesize: pageSize || null,
    };

    return api.create(Study_API.SUBJECT_CRF_SELECTALL + "SelectAll", payload);
  },

  insertSubjectCRFData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const fullPayload = {
      updatedby:user?.userid,
      ...payload,
    };
    return api.create(Study_API.SUBJECT_CRF_SELECTALL + "Insert", fullPayload);
  },
};
